// @perlab/cross-tab-idb — Object store name constants.
//
// Per spec §3.1 (28_Parallel_Work_Architecture_Tier1_V3.md), the 5 separate
// IDB object stores resolve MED N12 transaction contention vs the v1
// single-store design.
//
// Names match @perlab/cross-tab's KVStoreName union exactly — string-equal,
// not just compatible — so the adapter contract is one-to-one.

import type { KVStoreName } from '@perlab/cross-tab';

/** Theme / sidebar / inspector flags + other small UI key/values. */
export const STORE_KV: KVStoreName = 'kv';

/** id-keyed ShellNotification rows; leader writes, followers read. */
export const STORE_NOTIFICATIONS: KVStoreName = 'notifications';

/** Per-{userId, sessionId} keyed recent context list. */
export const STORE_RECENTS: KVStoreName = 'recents';

/** Type-keyed last snapshot envelope ring (one row per snapshot type). */
export const STORE_REPLAY: KVStoreName = 'replay';

/** Pinned context slots (cmd-K cmd-shift-1..5 bindings). */
export const STORE_PINNED: KVStoreName = 'pinned';

/** All 5 stores, in declaration order. Iterate when creating the DB. */
export const ALL_STORES: readonly KVStoreName[] = [
  STORE_KV,
  STORE_NOTIFICATIONS,
  STORE_RECENTS,
  STORE_REPLAY,
  STORE_PINNED,
] as const;

/** Database name + version. Bump VERSION on any store-name change. */
export const DB_NAME = 'perlab.shell';
export const DB_VERSION = 1;
